import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TOOLS } from "@/lib/tools";

export const ToolsPreview = () => {
  return (
    <section id="tools" data-testid="tools-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="reveal max-w-2xl">
            <span className="lw-eyebrow">Interactive Tools</span>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-lw-navy leading-[1.1]">
              Clarity, in <span className="italic">six calculators</span>.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-lw-muted">
              Education-first tools that translate complex products into
              plain-English answers. Try one in under a minute.
            </p>
          </div>
          <Link
            to="/tools"
            data-testid="tools-browse-all"
            className="btn-ghost-navy self-start lg:self-auto"
          >
            Browse all tools <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TOOLS.map(({ slug, name, blurb, duration, Icon, accent }) => (
            <Link
              to={`/tools/${slug}`}
              key={slug}
              data-testid={`tool-card-${slug}`}
              className="lw-card group p-6 sm:p-7 flex flex-col h-full"
            >
              <div className="flex items-start justify-between mb-5">
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                    accent === "gold"
                      ? "bg-lw-gold/15 text-[#8a6a2b]"
                      : "bg-lw-navy text-[#FAF8F3]"
                  }`}
                  aria-hidden="true"
                >
                  <Icon size={20} />
                </div>
                <span className="lw-pill">{duration.replace("Takes ~", "")}</span>
              </div>
              <h3 className="font-serif-display text-lg text-lw-navy leading-snug">
                {name}
              </h3>
              <p className="mt-2 text-sm text-lw-muted leading-relaxed flex-1">
                {blurb}
              </p>
              <span
                data-testid={`tool-cta-${slug}`}
                className="mt-6 inline-flex items-center gap-1.5 font-sans-ui text-sm font-semibold text-lw-navy group-hover:text-[#8a6a2b] transition-colors"
              >
                Try it <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsPreview;
